import type { ButtonProps } from "../types";

export const PRIMARY_PROPS = ({ settings }: { settings: ButtonProps }) => ({
  title: getParsedValue("titleVariable", "title", settings),
  url: getParsedValue("urlVariable", "url", settings, true),
  target: settings.target,
  color: settings.color,
  colorHover: settings.colorHover,
  background: settings.background,
  backgroundHover: settings.backgroundHover,
  borderColor: settings.borderColor,
  borderColorHover: settings.borderColorHover,
  round: settings.round,
  borderWidth: settings.borderWidth,
  analyticsClickEvent: settings.analyticsClickEvent,
  anchorName: settings.anchorName,
  anchorTrigger: settings.anchorTrigger,
  selectedLinkType: settings.selectedLinkType,
  openInPopup: settings.openInPopup,
  ...SHARED_PROPS({ settings }),
});

export const SECONDARY_PROPS = ({ settings }: { settings: ButtonProps }) => ({
  title: getParsedValue("titleVariableSecondary", "titleSecondary", settings),
  url: getParsedValue("urlVariableSecondary", "urlSecondary", settings, true),
  target: settings.targetSecondary,
  color: settings.colorSecondary,
  colorHover: settings.colorHoverSecondary,
  background: settings.backgroundSecondary,
  backgroundHover: settings.backgroundHoverSecondary,
  borderColor: settings.borderColorSecondary,
  borderColorHover: settings.borderColorHoverSecondary,
  round: settings.roundSecondary ?? settings.round,
  borderWidth: settings.borderWidthSecondary ?? settings.borderWidth,
  analyticsClickEvent: settings.analyticsClickEventSecondary,
  anchorName: settings.anchorNameSecondary,
  anchorTrigger: settings.anchorTriggerSecondary,
  selectedLinkType: settings.selectedLinkTypeSecondary,
  openInPopup: settings.openInPopupSecondary,
  ...SHARED_PROPS({ settings }),
});

const SHARED_PROPS = ({ settings }: { settings: ButtonProps }) => ({
  fontSize: settings.fontSize,
  horizontalAlignment: settings.horizontalAlignment,
  isBold: settings.isBold,
  textDirection: settings.textDirection,
});

// `keepEmpty`: a bound variable that resolved to "" stays "" instead of
// falling back to the static value. For links the static `url` is a leftover
// template default (someone else's calendar), so an empty variable must give
// an inert button, not that link. Unbinding clears the field to null, so ""
// only ever means "bound, value empty".
const getParsedValue = (
  variableKey: string,
  valueKey: string,
  settings: ButtonProps,
  keepEmpty = false,
): string => {
  const variable = settings[variableKey as keyof ButtonProps];
  const value = settings[valueKey as keyof ButtonProps];
  const isParsed =
    typeof variable === "string" &&
    (keepEmpty || variable !== "") &&
    !variable.includes("{{") &&
    !variable.includes("}}");
  return (isParsed ? variable : value) as string;
};
